export const OTHER_NOTIFIER_OPTION = Object.freeze({ label: 'Otra', value: 0 });
